import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const AGB = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Button 
          onClick={() => navigate('/')}
          variant="ghost"
          className="mb-8"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Zurück zur Startseite
        </Button>

        <div className="prose prose-slate max-w-none">
          <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>

          <h2>§ 1 Geltungsbereich</h2>
          <p>
            Diese Allgemeinen Geschäftsbedingungen gelten für alle Geschäftsbeziehungen zwischen der 
            2besales GmbH (nachfolgend "Auftragnehmer") und ihren Kunden (nachfolgend "Auftraggeber").
          </p>

          <h2>§ 2 Vertragsgegenstand</h2>
          <p>
            Gegenstand des Vertrages ist die Erbringung von Dienstleistungen im Bereich LinkedIn-Marketing, 
            insbesondere die Unterstützung bei der LinkedIn-Akquise, Netzwerkaufbau und Kommunikationsstrategie.
          </p>

          <h2>§ 3 Vertragsschluss</h2>
          <p>
            Der Vertrag kommt durch die Annahme des Angebots des Auftragnehmers durch den Auftraggeber zustande. 
            Die Annahme kann schriftlich, per E-Mail oder durch Zahlung erfolgen.
          </p>

          <h2>§ 4 Leistungsumfang</h2>
          <p>
            Der Umfang der zu erbringenden Leistungen ergibt sich aus dem jeweiligen Angebot und der 
            Leistungsbeschreibung. Änderungen und Ergänzungen bedürfen der Schriftform.
          </p>

          <h2>§ 5 Mitwirkungspflichten des Auftraggebers</h2>
          <p>
            Der Auftraggeber verpflichtet sich zur aktiven Mitarbeit und stellt alle für die Durchführung 
            des Auftrags erforderlichen Informationen, Materialien und Zugänge zeitnah zur Verfügung.
          </p>

          <h2>§ 6 Vergütung und Zahlung</h2>
          <p>
            Die Vergütung richtet sich nach dem vereinbarten Angebot. Rechnungen sind innerhalb von 14 Tagen 
            nach Rechnungsdatum ohne Abzug zur Zahlung fällig.
          </p>

          <h2>§ 7 Vertragslaufzeit und Kündigung</h2>
          <p>
            Die Vertragslaufzeit und Kündigungsfristen ergeben sich aus dem jeweiligen Angebot. Eine außerordentliche 
            Kündigung aus wichtigem Grund bleibt unberührt.
          </p>

          <h2>§ 8 Haftung</h2>
          <p>
            Der Auftragnehmer haftet für Schäden nur bei Vorsatz und grober Fahrlässigkeit. Die Haftung für 
            leichte Fahrlässigkeit ist ausgeschlossen, soweit nicht wesentliche Vertragspflichten betroffen sind.
          </p>

          <h2>§ 9 Geheimhaltung</h2>
          <p>
            Beide Vertragsparteien verpflichten sich, alle im Rahmen der Geschäftsbeziehung bekannt gewordenen 
            vertraulichen Informationen streng vertraulich zu behandeln.
          </p>

          <h2>§ 10 Urheberrechte</h2>
          <p>
            Alle vom Auftragnehmer erstellten Inhalte und Materialien bleiben bis zur vollständigen Bezahlung 
            Eigentum des Auftragnehmers. Eine Nutzung durch den Auftraggeber ist erst nach vollständiger Zahlung gestattet.
          </p>

          <h2>§ 11 Schlussbestimmungen</h2>
          <p>
            Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist München. Sollten einzelne Bestimmungen 
            dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
          </p>

          <p className="mt-8">
            <strong>2besales GmbH</strong><br />
            Lena-Christ-Str. 2<br />
            82031 Grünwald<br />
            E-Mail: info@2besales.de
          </p>
        </div>
      </div>
    </div>
  );
};

export default AGB;
